import { render, staticRenderFns } from "./NewTag.vue?vue&type=template&id=d2799c0e&scoped=true&"
var script = {}
import style0 from "./NewTag.vue?vue&type=style&index=0&id=d2799c0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2799c0e",
  null
  
)

export default component.exports